import { pathOr } from 'ramda'

import type { ServiceType } from '@/legacy-src/types/GeneralStateType'

import createResultCheckingSelector from '../memoize'
import type { ReduxState } from '../reducers'

const fetchingFilter = (state: ReduxState, key: string): number => pathOr(0, ['general', 'fetching', key], state)

export const servicesSelector = (state: ReduxState): ServiceType[] => pathOr([], ['general', 'services'], state)

export const fetchingSelector: (state: ReduxState, key: string) => boolean = createResultCheckingSelector(
  [fetchingFilter],
  (fetching: number) => fetching > 0,
)

export default {
  servicesSelector,
  fetchingSelector,
}
